import { useMessage } from 'app/context';
import { buildErrorMessage } from 'app/utils';
import { useState } from 'react';

export const useBasePaginatedList = <T>() => {
  const { error } = useMessage();

  //Filtri
  const [filter, setFilter] = useState<string>();

  //Paginazione
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(15);
  const [count, setCount] = useState<number>(0);

  //Loading
  const [loading, setLoading] = useState(false);

  //Lista
  const [list, setList] = useState<T[]>([]);

  const handlePageChange = (newPage: number) => {
    setPage(newPage);
  };

  const handlePageSizeChange = (newPageSize: number) => {
    setPageSize(newPageSize);
  };

  const handleSuccess = (data: T[], count: number) => {
    setList(data);
    setCount(count);
  };

  const handleError = (resp: any) => {
    error({ message: buildErrorMessage(resp) });
  };

  const handleFilter = (newFilter?: string) => {
    setFilter(newFilter);
  };

  return {
    page,
    setPage,
    pageSize,
    setPageSize,
    count,
    setCount,
    loading,
    setLoading,
    list,
    setList,
    handlePageChange,
    handlePageSizeChange,
    filter,
    handleFilter,
    handleSuccess,
    handleError,
  };
};
